module.exports = __webpack_public_path__ + "static/media/qr-with-cdh-img.aeea83fe.svg";